export default {
  common__validation__is_required: 'Поле необхідно заповнити',
  common__validation__invalid_format: 'Недійсний формат',
  common__validation__invalid_file_size: 'Розмір файлу перевищує максимальний ліміт ({size})',
};
